//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import { MdDeleteForever, MdModeEdit } from 'react-icons/md'
import { useForm } from 'react-hook-form'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import ModalReferenceFormModule from 'app_components/modules/admin/landings/modalReferenceForm'
//@end

// @import hooks
// @end

// @INFO Import types
import { IReferences, ILanding } from 'app_types/admin/landings/landingTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../referencesFormModule.scss'

// @ADD Component types
interface IReferencesFormModuleLayoutProps {
  landingInfo: ILanding | null
  loadingForm: 'loading' | null
  data?: Array<IReferences>
  source: string
  onHandleSaved: (data: any) => void | null
  handleDelete: (unique: string) =>any
  onHandleGeneralInfoSubmit: (data: any) => Promise<void | null>
}

const ReferencesFormModuleLayout: React.FC<IReferencesFormModuleLayoutProps> = (props) => {

  const [open, updateOpen] = useState<boolean>(false)
  const [editData, updateEditData] = useState<IReferences | undefined>(undefined)
  const formHook = useForm()

  const { t } = useTranslation()

  const handleCloseModal = (status?: boolean) => {
    updateOpen(false)
    updateEditData(undefined)
    if(status){
      props.onHandleSaved({status: 'success'})
    }
  }

  const handleClickEdit = (element: IReferences) => {
    updateEditData(element)
    updateOpen(true)
  }

  const handleClickDelete = async (element: IReferences) => {
    await props.handleDelete(element.unique)
  }

  return(
    <div className='references_form_module-layout'>
      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">Nuestras referencias</h3>
      </div>

      <form
        onSubmit={formHook.handleSubmit(props.onHandleGeneralInfoSubmit)}
        className="form-general-info"
      >
        <div className="row">
          <div className="col-8">
            <div className='form-group '>
              <label htmlFor='title_references'>{t('labels.teacher_landing_form.title_references')}</label>
              {formHook.errors.title_references && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              <input
                id='title_references'
                name='title_references'
                className={`form-control ${formHook.errors.title_references && 'is-invalid'}`}
                type='text'
                ref={formHook.register({ required: true })}
                defaultValue={props?.landingInfo?.landing?.title_references}
              />
            </div>
          </div>
          <div className="col-4 button-right">
            <button className='btn btn-primary button-with-spinner' type='submit' disabled={props.loadingForm === 'loading'}>
              {props.loadingForm === 'loading' && (
                <>
                  <div className="spinner-border spinner-loading-button" role="status"></div>&nbsp;&nbsp;
                </>
              )}
              {t('buttons.save')}
            </button>
          </div>
        </div>
      </form>

      <div className="button-container-landing">
        <ButtonComponent
          variant='primary'
          style={{
            width: 'fit-content'
          }}
          onClick={() => updateOpen(true)}
        >
          Nueva referencia
        </ButtonComponent>
      </div>

      {props.data?.length ?
        props.data.map((item) => (
          <div
            key={item.unique}
            className='item-reference'
          >
            <div className="container-icons">
              <MdModeEdit
                onClick={() => handleClickEdit(item)}
              />
              <MdDeleteForever
                onClick={() => handleClickDelete(item)}
              />
            </div>
            {/* <img src={item.url} alt="" /> */}
            <div>
              <TextComponent
                type='text'
              >
                {item.title}
              </TextComponent>
              <TextComponent
                type='text'
              >
                {item.description}
              </TextComponent>
              <TextComponent
                type='text'
                style={{fontSize: '0.875rem', fontWeight: 700, color: item.active || item.active === undefined ? 'var(--primary)' : undefined}}
              >
                {item.active || item.active === undefined ? 'Activa' : 'Inactiva'}
              </TextComponent>
            </div>
          </div>
        ))
      :
        <AlertComponent
          description='Aún no has agregado referencias'
          type='info'
        />
      }
      {open ?
        <ModalReferenceFormModule
          open={open}
          source={props.source}
          editData={editData}
          onClose={handleCloseModal}
        />
      :null}
    </div>
  )
}

export default ReferencesFormModuleLayout
